import { environment } from 'projects/mmb-web-app/src/environments/environment';
import { ONBOARDING_COPY } from '../onboarding/onboarding-copy.const';

/** Default heading for `/join` and register modal when no custom `title` is passed. */
export const Register_Initial_Title = ONBOARDING_COPY.register.title;

/** Default subcopy under the register heading. */
export const Register_Initial_SUBTITLE = ONBOARDING_COPY.register.subtitle;

export const Register_Static_Images:string[] = [
    '../../../assets/banners/register-bg-1.jpeg',
    '../../../assets/banners/register-bg-2.jpeg',
];

export const Register_Linked_Credentials = {
    clientId: environment.linkedIn.clientId,
    redirectUrl: `${window.location.origin}/login`,
    scope: environment.linkedIn.scope // To read basic user profile data and email
};

export interface OriginalName {
    firstName?: string,
    lastName?: string
}